export default {
  product: {
    title: 'Producto',
    selfCustodyWallet: 'Billetera Movil',
    selfCustodyWalletDesc: 'Billetera móvil Crypto & DeFi en Blockchain.',
    hardwareWallet: 'Billetera de hardware',
    hardwareWalletDesc: 'Obten tu KeyPal, para proteger tus activos.',
    extensionWallet: 'Billetera de Extensión',
    extensionWalletDesc: 'Una mejor billetera en su computadora.',
    transit: 'Transit',
    transitDesc:
      'Agregador DEX multicadena y plataforma de mercado para el intercambio de NFT.',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Protocolo de red social en Web3.0.',
    stakeVault: 'ETH Staking Vault',
    stakeVaultDesc:
      'Soporta tanto el staking de auto-custodia como el staking de pequeñas cantidades',
  },
  project: {
    subToken: 'Enviar token',
    subDApp: 'Enviar DApp',
    subNFT: 'Enviar NFT',
    subChain: 'Cadena',
  },
  assets: {
    title: 'Activos',
  },
  collaborations: {
    title: 'Colaboraciones',
  },
  community: {
    title: 'Comunidad',
    developers: 'Desarrolladores',
    recruiting: 'TP Man',
  },
  helpCenter: {
    title: 'Ayuda',
  },
  features: {
    title: 'Características',
    buyCrypto: 'Compra cripto',
    mobileWallet: 'Billetera móvil',
    hardwareWallet: 'Billetera de hardware',
    extensionWallet: 'Extensión de la Billetera',
    desktop: 'Cartera de escritorio',
    fiveDegrees: '5Degrees',
    versionVerification: 'Version Verification',
    approvalDetector: 'Detector de aprobación',
    tokenSecurity: 'Seguridad de Token',
    keyGenerator: 'Generador de Claves',
    BATCH_SENDER: 'Envío por lotes',
  },
  information: {
    title: 'Información',
    blockchainGuide: 'Guía de cadena de bloques',
    tronWallet: 'Guía de TRON',
    iostWallet: 'Guía de IOST',
    tpMan: 'TP Man',
  },
  developers: {
    title: 'Desarrolladores',
    github: 'Github (TP-Lab)',
    devCenter: 'Centro de Desarrollo',
    subToken: 'Enviar token',
    subDApp: 'Enviar DApp',
    subNFT: 'Enviar NFT',
  },
  company: {
    title: 'Compañía',
    about: 'Acerca de',
    careers: 'Empleos',
    pressKit: 'Kit de Prensa',
    swagShop: 'Tienda de artículos de regalo',
  },
  support: {
    title: 'Soporte',
    helpCenter: 'Centro de Asistencia',
    contactUs: 'Contáctanos',
  },
  legal: {
    title: 'Legal',
    privacyPolicy: 'Política de Privacidad',
    terms: 'Términos de Uso',
  },
  main: {
    title: 'Verificación de Versión',
    language: 'Español',
    intro:
      'La verificación de versión se realiza mediante la coincidencia de los valores hash MD5 o SHA256 entre las versiones. Asegúrese de descargar la billetera TokenPocket a través de canales oficiales para evitar ser engañado. Para obtener instrucciones sobre cómo obtener los valores hash MD5 o SHA256 de una versión, por favor ',
    tutorial: 'consulte el tutorial >',
    system: 'Sistema Operativo',
    android: 'Android',
    ios: 'iOS',
    version: 'Versión',
    allVersion: 'Todas',
    appChannel: 'Canal de la Aplicación',
    developer: 'desarrollador',
    allChannel: 'Todos',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Registro de Versión',
    check: 'Detalles',
    versionLog: 'Registro de Versión',
    confirm: 'Confirmar',
    aboutIOS: 'Acerca de la Versión de iOS',
    IOSDesc:
      'Para las versiones de iOS, solo ofrecemos nuestra aplicación en la App Store. Solo las aplicaciones descargadas a través de la App Store se pueden instalar correctamente. Por lo tanto, al usar dispositivos Apple, asegúrese de autenticar la App Store como el único canal de descarga.',
    IOSDesc_2:
      'El desarrollador de la versión descargada de la App Store antes del 8 de octubre de 2022 es TOKENPOCKET FOUNDATION LTD, que es una versión temprana desarrollada por TokenPocket. Es una billetera legítima que se puede utilizar normalmente, pero el servicio de actualización se suspenderá temporalmente.',
    aboutAndroid: 'Acerca de la versión de Android',
    androidDesc: 'Las opciones de descarga de TokenPocket para Android actualmente incluyen el sitio web oficial, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store y Vivo App Store. En algunas tiendas de aplicaciones, no se puede obtener el archivo de instalación APK durante el proceso de descarga, por lo que no se puede realizar la verificación MD5 o SHA256. Por lo tanto, al descargar, asegúrese de verificar claramente la información del desarrollador consultando lo siguiente!',
    IOSAppName: 'Nombre de la Aplicación:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Ícono de la Aplicación:',
    AppDeveloper: 'Desarrollador:',
    downloadLink: 'URL de Descarga:',
    copied: '¡Copiado!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Síganos',
    desc1: 'TokenPocket Staffs no te enviará mensajes privados!',
    desc2:
      '¡Precaución! Está ingresando a la comunidad TokenPocket, ¡podría haber alguien haciéndose pasar por nosotros para enviarle mensajes privados! ¡Tenga en cuenta que cualquier persona que envíe mensajes privados podría ser un estafador! ¡Nunca te contactaremos primero!',
    desc3: 'Entendido, entra'
  },
};
